export function editorFieldResource(stageId, bindText) {
  const fields = {
    cfe_time: "times",
    chatbot_formatacao_entrada_id: "formatacao",
    sistema_licenciada_id: "sistemas",
    chatbot_campanha_id: "modelos",
    callback_comando_id: "callbacks",
    modelo_link_id: "links",
    chatbot_agenda_id: "agendas",
    chatbot_fluxo_outros_id: "fluxos",
    atributos_customizaveis: "atributos",
    caixa_entrada: "caixas"
  };
  if (bindText === "cfe_atributo") {
    if (Number(stageId) === 27) return "marcadores";
    if (Number(stageId) === 22) return "fluxos";
  }
  return fields[bindText] || null;
}
